<!--

  @copyright Copyright (c) Open-Xchange GmbH, Germany <info@open-xchange.com>
  @license AGPL-3.0

  This code is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with OX App Suite. If not, see <https://www.gnu.org/licenses/agpl-3.0.txt>.

  Any use of the work other than as authorized under this license or copyright law is prohibited.

-->

<template>
  <div ref="categoryBadgesViewPlaceholder" ></div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { CategoryBadgesView } from '@/io.ox/core/categories/view'
import Backbone from '@/backbone'
import { categoriesCollection } from '@/io.ox/core/categories/api'

const props = defineProps(['collection', 'searchable', 'closable', 'limit', 'removable'])
// allow an array of ids instead of a real backbone collection too.
// This way components using this don't have to import backbone and the categories collection
const collection = props.collection instanceof Backbone.Collection
  ? props.collection
  : new Backbone.Collection(
    categoriesCollection.filter(category => {
      return (props.collection || []).includes(category.id) ||
        (props.collection || []).includes(category.get('name'))
    })
  )
const categoryBadgesView = new CategoryBadgesView({ ...props, collection })

// render elements that are not part of the template. Backbone views etc
const categoryBadgesViewPlaceholder = ref()
onMounted(() => categoryBadgesViewPlaceholder.value.replaceWith(categoryBadgesView.render().el))
</script>
